import * as NamaURLS from "../../constants/NamaURLS";
import {ajaxJSONWithoutWait} from "../../common/NamaCommon";
import {EditPlace} from "../../routing/places";
import * as ViewMode from "../../constants/ViewMode";
import * as editPresenter from "../../routing/EditPresenter";

export class SimpleEntityView {
    constructor(entityType, objectOrCriteria) {
        this.simpleEntityType = entityType;
        if (objectOrCriteria.expressions)
            this.criteria = objectOrCriteria;
        else
            this.object = objectOrCriteria;
        this.fetchSimpleEntity();
    }

    fetchSimpleEntity() {
        let that = this;
        if (that.object && !that.criteria) {
            that.show(that.object);
        } else {
            let request = {
                entityType: that.simpleEntityType,
                criteria: that.criteria,
                page: 0,
                pageSize: 1
            };
            let contextInfo = null;
            ajaxJSONWithoutWait(NamaURLS.ListPageMatching, {
                request: JSON.stringify(request),
                contextInfo: JSON.stringify(contextInfo),
            }, (result) => {
                if (result && result.length > 0) {
                    this.object = result[0];
                    that.show(result[0]);
                }
            });
        }
    }

    show(object) {
        let that = this;
        that.container = $(`
                <div id=${object.id}>
                </div>`);
        let container = that.container;
        container.appendTo($("body"));
        container.kendoWindow({
            width: "75%",
            title: translateId("showGeneratedSystemTransaction") + " - " + translateId(that.simpleEntityType),
            modal: true,
            resizable: true,
            draggable: true,
            scrollable: true,
            position: {
                top: "5%",
                left: "10%"
            },
            close: function (e) {
                container.data("kendoWindow").destroy()
            }
        });
        let place = new EditPlace();
        place.entityType = that.simpleEntityType;
        place.createdObject = object;
        place.view = ViewMode.VIEW;
        place.simpleEntityView = true;
        that.currentPresenter = new editPresenter.EditPresenter(place);
        that.currentPresenter.simpleEntityContainer = container;
        that.currentPresenter.start();

    }
}